/* Display-only mark replacement. Never rewrite href/src, identifiers, SKUs or script data. */
(() => {
  'use strict';
  if (window.ceBrandMarksLoaded) return;
  window.ceBrandMarksLoaded = true;
  const skipped = 'script,style,noscript,textarea,input,select,option,code,pre,svg,math,[contenteditable="true"],[data-ce-preserve-trademark],.product__sku,[id^="Sku-"]';
  const pattern = /\u2122|&(?:trade|#0*8482|#x0*2122);/gi;
  const convert = value => value.replace(pattern, '\u00ae');
  const allowed = node => node.parentElement && !node.parentElement.closest(skipped);
  function text(node) {
    if (!allowed(node)) return;
    const value = convert(node.nodeValue);
    if (value !== node.nodeValue) node.nodeValue = value;
  }
  function attributes(element) {
    if (element.closest(skipped)) return;
    for (const attribute of ['alt', 'title', 'aria-label']) {
      const original = element.getAttribute(attribute);
      if (original !== null) {
        const value = convert(original);
        if (value !== original) element.setAttribute(attribute, value);
      }
    }
  }
  function process(root) {
    if (root.nodeType === Node.TEXT_NODE) { text(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE) {
      if (root.closest(skipped)) return;
      attributes(root);
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) text(walker.currentNode);
    root.querySelectorAll('[alt],[title],[aria-label]').forEach(attributes);
  }
  function start() {
    process(document.body);
    const title = convert(document.title);
    if (title !== document.title) document.title = title;
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') text(record.target);
        else if (record.type === 'attributes') attributes(record.target);
        else record.addedNodes.forEach(process);
      }
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true,
      attributes: true, attributeFilter: ['alt', 'title', 'aria-label'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
